import { APP_BASE_HREF } from '@angular/common';
import {
  AfterContentChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { QueuesService } from '@app/_core/services/queues.service';
import { UserService } from '@app/_core/services/user.service';
import { MainControllerComponent } from 'src/app/pages/queue/dialer/MainController.component';
@Component({
  selector: 'app-search-dialog-details',
  templateUrl: './search-dialog-details.component.html',
  styleUrls: ['./search-dialog-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class SearchDialogDetailsComponent implements OnInit, AfterContentChecked, OnChanges {
  @Input()
  searchData: any = [];
  @Input()
  originalSearchResult: any = [];
  @Input()
  isEmail: any;
  @Input()
  searchType = 'user';
  @Output() emitBackClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitDataChange: EventEmitter<any> = new EventEmitter<any>();
  innerHeight: any = 10;
  dataToDisplay: any = [];
  cols: any;
  colsDetail: any;
  @Input() URL: string;
  filteredData: { label: string; value: any }[];
  SearchableFieldResponsesArray: any;
  searchedData: any = [];
  showElsePart: boolean = true;
  constructor(
    private utils: Utils,
    private cdr: ChangeDetectorRef,
    public queueService: QueuesService,
    private userService: UserService,
    private appService: AppService,
    private managerService: ManagerService,
    private mainController: MainControllerComponent,
    @Inject(APP_BASE_HREF) public baseHref: string
  ) {}

  // cols:any=[]
  // colsDetail: any=[]
  selectedData: any = [];

 

  agentCols = [{ name: 'FullName', label: 'Name', showFilter: false }];

  userCols = [
    { name: 'FullName', label: 'Name', showFilter: false },
    { name: 'Company', label: 'Company', showFilter: false },
    { name: 'PhoneNumbers', label: 'Phone #', showFilter: false },
    { name: 'CrmUserID', label: 'External ID', showFilter: false },
    { name: 'SourceSystem', label: 'Source System', showFilter: false },
  ];

  // agentColsDetail = [
  //   { name: 'FirstName', label: 'First Name', showFilter: false },
  //   { name: 'LastName', label: 'Last Name', showFilter: false },
  //   { name: 'FullName', label: 'Name', showFilter: false },
  //   { name: 'EmailAddress', label: 'Email Address', showFilter: false },
  //   { name: 'City', label: 'City', showFilter: false },
  //   { name: 'Country', label: 'Country', showFilter: false },
  //   { name: 'State', label: 'State', showFilter: false },
  //   { name: 'Score', label: 'Score', showFilter: false },
  //   { name: 'CrmUserID', label: 'External ID', showFilter: false },
  //   { name: 'SourceSystem', label: 'Source System', showFilter: false },
  // ];

  // userColsDetail = [
  //   { name: 'FirstName', label: 'First Name', showFilter: false },
  //   { name: 'LastName', label: 'Last Name', showFilter: false },
  //   { name: 'FullName', label: 'Name', showFilter: false },
  //   { name: 'EmailAddress', label: 'Email Address', showFilter: false },
  //   { name: 'City', label: 'City', showFilter: false },
  //   { name: 'Country', label: 'Country', showFilter: false },
  //   { name: 'State', label: 'State', showFilter: false },
  //   { name: 'Score', label: 'Score', showFilter: false },
  //   { name: 'CrmUserID', label: 'External ID', showFilter: false },
  //   { name: 'SourceSystem', label: 'Source System', showFilter: false },
  // ];
  ngOnChanges(changes: SimpleChanges): void {
   // console.log(changes);
    this.dataToDisplay = changes['searchData'].currentValue.Response.Data;
    this.filterSearchDetails(this.dataToDisplay);
  }
  ngOnInit(): void {
    this.queueService.elsePartVisible$.subscribe(visible => {
      this.showElsePart = visible;
    });

    this.queueService.backClicked$.subscribe(value => {
      if (value === 2) {
        this.retrunToPrevious(); //
      }
    });
    if (this.searchType == 'user') {
      this.cols = this.userCols;
    } else {
      this.cols = this.agentCols;
      // this.colsDetail = this.agentColsDetail;
    }
    this.dataToDisplay = this.searchData.Response.Data;
    this.filterSearchDetails(this.dataToDisplay);

    if (this.dataToDisplay.length == 1) {
      this.getAvatarByID(this.dataToDisplay[0].UserID);
    }

   // console.log(this.dataToDisplay);
    this.setInnerWidthHeightParameters();
    this.addIsSelected();
  }

  getAvatarByID(userID: any) {
    this.userService.getAvatarByUserID(userID).subscribe(async response => {
    //  console.log('user Avatar', response.Response.Data);
      const txtURL = response.Response.Data;
      if (txtURL !== null && txtURL !== undefined) {
        this.getImage(response.Response.Data);
      } else {
        this.URL = this.baseHref + '/assets/images/icon-user-pic.png';
      }
    });
  }

  getImage(file: any) {
    this.managerService.getRecordingFiles(file).subscribe(data => {
     // console.log('getImageAvatar', data);
      this.URL = 'data:' + data.MimeType + ';base64,' + data.result;
    });
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
    this.dataToDisplay = this.searchData.Response.Data;
  }

  addIsSelected() {
    this.dataToDisplay.forEach(ele => {
      ele.isSelected = false;
    });
  }

  setInnerWidthHeightParameters() {
    // this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight * 0.5;
  }

  onRowSelect() {
    this.appService.setHasOpenedQNX(false);
    this.showElsePart = true;
    if (this.isEmail) {
      this.dataToDisplay.forEach(ele => {
        if (ele['UserID'] === this.selectedData['UserID']) {
         //console.log(ele['UserID']);

          if (ele['isSelected'] == false) {
            ele['isSelected'] = true;
            this.queueService.toAddEmailArrayFunction(ele);
          }
        }
      });
    } else {
      this.dataToDisplay.forEach(ele => {
        if (ele['UserID'] === this.selectedData['UserID']) {
          this.dataToDisplay = [this.selectedData];
         // console.log(this.dataToDisplay, 'detailed data');
          this.filterSearchDetails(this.dataToDisplay);
        }
      });
      this.getAvatarByID(this.dataToDisplay[0].UserID);
      this.emitBackClicked.emit(1);
      this.emitDataChange.emit(this.dataToDisplay);
    }
    // console.log(this.dataToDisplay);
  }

  filterSearchDetails(searchedData) {
  //  console.log(searchedData);
    this.searchedData = searchedData;
    this.filteredData = this.convertToLabelValuePairs(this.searchedData[0]);    
    this.filteredData=this.filteredData.filter(item => item.value !== null && item.value !== undefined && item.value !== '');    
   // console.log(this.filteredData)
   this.filteredData.forEach(ele => {
      if (ele.label == 'ShortVanityID') {
        ele.label = 'ID';
      }
      else if (ele.label == 'PhoneNumbers') {
        if(ele.value.length>0) ele.value=ele.value[0]?.Number;
        else ele.value='';
      }
      if (ele.label == 'SearchableFieldResponses' && ele.value ) {
      //  console.log(ele);
        let newArray = [];
        if (ele.value) {
          newArray = ele.value.map(item => {
            return {
              label: item.FieldName,
              value: item.Values,
            };
          });
        }

        this.SearchableFieldResponsesArray = newArray;
       // console.log(newArray);
      }
      if (ele.label == 'CustomResponses' && ele.value) {
      //  console.log(ele);
        let newArray = [];
        // if (ele.value) {
        //   newArray = ele.value.map(item => {
        //     return {
        //       label: item.FieldName,
        //       value: item.Values,
        //     };
        //   });
         newArray = this.convertToLabelValuePairs(ele.value);
        

        this.SearchableFieldResponsesArray = newArray;
       // console.log( this.SearchableFieldResponsesArray)
       // console.log(newArray);
      }
    });

    this.filteredData = this.filteredData.filter(
      i =>
        i.value != null &&
        typeof i.value !== 'object' &&
        (i.value.length >= 0 || (typeof i.value == 'number' && i.value > 0)) &&
        i.label != 'PostalCode' &&
        i.label != 'UserID' &&
        i.label != 'VanityID' &&
        i.label != 'Role' &&
        i.label != 'RoleID' &&
        i.label != 'CountryID' &&
        i.label != 'StateID' &&
        i.label != 'Industry' &&
        i.label != 'StateAbbrev'
    );

   // console.log(this.filteredData);
    this.filteredData =this.filteredData.concat(this.SearchableFieldResponsesArray);
    //console.log(this.filteredData);
  }
  convertToLabelValuePairs(obj) {
    return Object.keys(obj).map(key => ({
      label: key,
      value: obj[key],
    }));
  }
  retrunToPrevious() {
    this.dataToDisplay = this.searchData.Response.Data;
    this.emitBackClicked.emit(0);
  }

  // toggleCustomColumnFilter(data) {}

  sortByColumn(colName: string) {
    this.dataToDisplay = this.utils.sortByField(colName, this.cols, this.dataToDisplay);
  }
  getDialerType() {
    return this.mainController.getDialerType();
  }
  shouldShowElsePart(): boolean {
    return this.showElsePart && this.getDialerType() === 'Keypad';
  }  
}
